import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { map, uniqBy } from 'lodash';
import TableColumnFilter from '../TableColumnFilter';
import isTextColumn from '../../utils/isTextColumn';

const ReportDetailsTableHeader = ({
  title,
  keyName,
  isFilter,
  records,
  filter,
  filtering
}) => {
  if (isFilter) {
    return (
      <th>
        <TableColumnFilter
          id={`${keyName}Filter`}
          options={map(uniqBy(records, keyName), record => record[keyName])}
          filtering={filtering[keyName] || []}
          onSelectHandler={filter(keyName)}
          keyName={keyName}
        >
          {title}
        </TableColumnFilter>
      </th>
    );
  } else {
    return (
      <th>
        <div
          className={classNames({
            'right-to-left-header': !isTextColumn(keyName || title)
          })}
        >
          {title}
        </div>
      </th>
    );
  }
};

ReportDetailsTableHeader.propTypes = {
  title: PropTypes.string.isRequired,
  keyName: PropTypes.string.isRequired,
  isFilter: PropTypes.bool,
  records: PropTypes.array.isRequired,
  filter: PropTypes.func.isRequired,
  filtering: PropTypes.object.isRequired
};

export default ReportDetailsTableHeader;
